import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DropDownFormatter } from "../../Entities/DropDownFormatter.ts";
import Card from "../../Utils/Cards/card-component.js";
import CodeSnippet from "../../Utils/CodeSnippet/code-snippet-component.js";
import DropDown from "../../Utils/DropDown/drop-down-component.js";
import Navbar from "../../Utils/Navbar/navbar-component.js";
import * as TrafficActions from '../../Redux/Traffic/TrafficActions.js';
import { Modal } from "../../Utils/Modal/modal-component.js";
import { LoadingAnimation } from "../../Utils/Progress/progress-component.js";
import SkeletonImage from "../../Utils/Skeleton/skeleton-image-component.js";
import SkeletonText from "../../Utils/Skeleton/sketelton-text-coomponent.js";
import AeraChart from "../../Utils/Charts/AreaChart.js";
import DougnutChart from "../../Utils/Charts/DougnutChart.js";
import { useNavigate } from "react-router";
import SkeletonBuilder from "../../Utils/Skeleton/skeleton-builder-component.js";
import Footer from "../../Utils/Footer/footer-component.js";

function Usage() {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const loading = useSelector((state) => state.loading);
    const rawTraffic = useSelector((state) => state.traffic.rawTraffic);
    const userCapacity = useSelector((state) => state.traffic.capacity);
    const userUsage = useSelector((state) => state.traffic.usage);


    const handleChangeLanguage = async (e) => {
        e.preventDefault();
        const period = e.target.value.split(",")[1];
        const currentPeriod = e.target.value.split(",")[0];
        console.log(`period:`, period);
        setPeriodFilter(period);
        setCurrentInterval([period, 'choose period']);
        dispatch(TrafficActions.getRawUserTraffic(period));
    };


    const getRawUserData = async (e) => {
        e.preventDefault();
        dispatch(TrafficActions.getRawUserTraffic(periodFilter));
        // setResponseAction('reponse');
    };

    const getUserCreditCapacity = async (e) => {
        e.preventDefault();
        dispatch(TrafficActions.getUserCreditCapacity());
        // setResponseAction('reponse');
    };

    const getUserUsage = async (e) => {
        e.preventDefault();
        dispatch(TrafficActions.getRawUsageUserCredit());
        // setResponseAction('reponse');
    };

    const updateApiServie = async (service) => {
        const targetService = await intervalFormatter.find(obj => obj.id === service);

        // const apiRequestFormatted = await formatCodeTemplate(codeLanguagesTemplate[currentSelectedLangauge], targetService);
        // setCurrentService(targetService);
        // setApiServiceRequest(apiRequestFormatted);
    }


    const [periodFilter, setPeriodFilter] = useState('DAY');
    const [currentInterval, setCurrentInterval] = useState(['Day', 'choose period']);

    const chooseLanguage = { name: "Change period", logo: 'M14.25 9.75L16.5 12l-2.25 2.25m-4.5 0L7.5 12l2.25-2.25M6 20.25h12A2.25 2.25 0 0020.25 18V6A2.25 2.25 0 0018 3.75H6A2.25 2.25 0 003.75 6v12A2.25 2.25 0 006 20.25z' };
    const intervalFormatter = new DropDownFormatter([
        { id: 1, name: 'Day', value: 'DAY' },
        { id: 2, name: 'Month', value: 'MONTH' },
        { id: 3, name: 'All', value: 'ALL' }

    ], handleChangeLanguage);


    useEffect(() => {
        dispatch(TrafficActions.getRawUsageUserCredit());
        dispatch(TrafficActions.getUserCreditCapacity());
        dispatch(TrafficActions.getRawUserTraffic(periodFilter));
    }, [dispatch, periodFilter]);



    <Modal expand={loading.visible}>
        <LoadingAnimation loadingMessage={loading.message} />
    </Modal>


    return (
        <div className="">
            <div className="h-full w-full flex flex-row">
                <div className="min-h-full w-full">

                    <Navbar />
                    <main className="transition-all duration-300">
                        <div className="block mx-auto max-w-7xl py-6 sm:px-6 lg:px-8">
                            <div className="px-4 py-6 sm:px-0">
                                <div className="flex h-full my-2 rounded-lg border-4 border-dashed border-gray-200 dark:border-gray-500 flex-col transition-all duration-300">
                                    <div className="flex justify-between flex-col lg:flex-row" >
                                        <div className="inline-flex flex-col justify-center align-middle items-center my-4 px-10">
                                            <h1 className="text-lg text-center font-bold text-gray-600 lg:text-2xl sm:px-16  dark:text-gray-200">Services Usage</h1>
                                            {userUsage ? <DougnutChart chartData={userUsage} /> : <div className="justify-center"><SkeletonBuilder type="PieChart" /></div>}
                                        </div>

                                        <div className="flex w-full h-full justify-center align-middle px-10">
                                            <div className="flex flex-col w-full h-full max-w-sm p-6 ">
                                                {userCapacity != null ? <h2 className="text-4xl my-4 font-bold tracking-tight text-gray-900 dark:text-gray-50"> {`${userCapacity.total_credit}/${userCapacity.credit}`}</h2> : <SkeletonText />}
                                                <p className="my-4 w-full text-lg text-center font-normal text-gray-500 lg:text-xl sm:px-16 dark:text-gray-400">Get more credits</p>
                                                <div className="inline-flex justify-center align-middle items-center ">
                                                    <button className="button-component px-5 font-medium" onClick={(e) => { e.preventDefault(); navigate('/home') }} >Upgrade account</button>
                                                </div>
                                            </div>
                                            {/* <div className="flex flex-col w-full h-full max-w-sm p-6 bg-white border border-gray-200 rounded-lg shadow  dark:bg-gray-800 dark:border-gray-700"> */}
                                            {/* <h5 className="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">{cardAdapter.title}</h5> */}
                                        </div>

                                    </div>
                                </div>
                                <div className="flex h-full rounded-lg border-4 border-dashed border-gray-200 dark:border-gray-500 flex-col">
                                    {/* <button onClick={getServices}>getServices</button> */}
                                    {/* <button onClick={getRawUserData}>getRawUserData</button> */}
                                    {/* <button onClick={getUserPointsCapacity}>getRawUserData</button> */}
                                    {/* <button onClick={getUserUsage}>getUserUsage</button> */}
                                    {/* {userUsage && <h3>{JSON.stringify(userUsage, null, 2)}</h3>} */}
                                    {/* {userCapacity && <h3>{JSON.stringify(userCapacity, null, 2)}</h3>} */}
                                    {/* {rawTraffic && <h3>{JSON.stringify(rawTraffic, null, 2)}</h3>} */}
                                    {/* {loading.visible && <SkeletonImage />} */}
                                    <div className="flex flex-row justify-start py-5">
                                        <DropDown buttonDrop={chooseLanguage} infoDrop={currentInterval} bodyDrop={intervalFormatter} />
                                    </div>
                                    {rawTraffic ? <AeraChart chartData={rawTraffic} interval={periodFilter} /> : <SkeletonImage />}
                                </div>
                            </div>
                        </div>
                    </main>
                </div>
            </div >
            <Footer />
        </div >
    );
}

export default Usage;